import { CFbuildAudioPlayer } from './audio_player'

const MODAL_POPUP_ID = 'modalPopup'
let cfMousePosition = 0
let isAudioInitialized = false

/**
 *
 * @param {string} $ID - The DOM element ID of the popup to show
 * @param {string} $type - The animation type ("fade", "scale", "left", "right", "top", "bottom")
 * @param {number} $delay - The delay before firing the animation (in ms)
 */
export function setPopUpTop(): void {
  const $el = $('#' + MODAL_POPUP_ID)
  const $body = $(document.body)
  const $containerModal = $('.containerModal')
  const $modalBackdrop = $('.modal-wrapper')
  $el.addClass('displayImportantTimed')
  $el.show()

  // to make the drop effect
  $containerModal.css('top', -800)

  if ($el.hasClass('containerModal')) {
    $el.addClass('popup-relative-position')

    // make the page not scrollable
    $body.addClass('remove-page-scroll')

    $containerModal.show()
    $modalBackdrop.show()
    if (!isAudioInitialized) {
      isAudioInitialized = true
      CFbuildAudioPlayer($('.containerModal .elAudioWrapper'))
    }
    $modalBackdrop.css({
      opacity: 1,
      top: 0,
    })
    $containerModal.animate(
      {
        opacity: 1,
        top: 0,
      },
      {
        duration: 200,
      }
    )
  }
}

function setupPopHandlers(): void {
  const $containerModal = $('.containerModal')
  const $modalBackdrop = $('.modal-wrapper')
  const $body = $(document.body)
  const $el = $('#' + MODAL_POPUP_ID)

  $(document).on('click', '.closeLPModal, .modal-wrapper', function () {
    $containerModal.animate(
      {
        opacity: 0,
        top: -800,
      },
      {
        duration: 200,
        complete: function () {
          $modalBackdrop.css({
            opacity: 0,
            top: -800,
          })
          $modalBackdrop.hide()
          $containerModal.hide()
          $el.removeClass('popup-relative-position')
        },
      }
    )
    // make the page scrollable again
    $body.removeClass('remove-page-scroll')
    return false
  })

  $(document).on('click', '.containerModal', function (event) {
    event.stopPropagation()
  })

  if ($containerModal.attr('data-show-popup-on-exit') === 'true') {
    setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave)
      document.addEventListener('mousemove', handleMouseMove)
    }, 500)
  }
}

function handleMouseMove(evt) {
  cfMousePosition = evt.pageY
}

function handleMouseLeave(): void {
  if (cfMousePosition <= 40) {
    setPopUpTop()
    document.removeEventListener('mouseleave', handleMouseLeave)
    document.removeEventListener('mousemove', handleMouseMove)
  }
}

window.addEventListener('load', setupPopHandlers)
